import { t } from "../../services/utils";
import { CREATE_ACCESS_TOKEN } from '../../constants/action-types';
export const createAccessTokenRequest = (email, password, redirectTo) => ({
  type: CREATE_ACCESS_TOKEN.REQUEST,
  payload: {
    email,
    password,
    redirectTo
  }
});